import { InvoicePaymentStatus, InvoicePaymentFilter } from '../../models/invoice-payment-status';

export const EditFields = {
    left: ['invoiceNumber', 'branchName', 'companyName'],
    right: ['creationDate', 'fromDate', 'duePaymentDate'],
};

export const Fields = {
    left: ['branchName', 'companyName', 'countMonths', 'fee', 'discount', 'total'],
    right: ['creationDate','fromDate', 'duePaymentDate', 'deviceCount', 'state', 'paid'],
};

export const invoiceStateOptions = [
    { name: '', value: '' },
    { name: 'written', value: 'WRITTEN' },
    { name: 'sent by mail', value: 'SENT_BY_MAIL' },
    { name: 'delivered to distributor', value: 'DELIVERED_TO_DISTRIBUTOR' },
];

export const invoiceStatuses: InvoicePaymentFilter[] = [InvoicePaymentFilter.All, InvoicePaymentStatus.Paid, InvoicePaymentStatus.Unpaid, InvoicePaymentFilter.Partial];

export const invoicePayment = ['all', 'cash', 'bank', 'card'];

export const invoiceStatus = [
    { name: 'unpaid', value: InvoicePaymentStatus.Unpaid },
    { name: 'paid', value: InvoicePaymentStatus.Paid }
];

export const invoicePaymentOptions = [
    { name: 'cash', value: 'cash' },
    { name: 'bank', value: 'bank' },
    { name: 'card', value: 'card' },
];

export const invoiceTaskTypes = [
    { name: 'Installation', value: 'INSTALLATION' },
    { name: 'Maintenance', value: 'MAINTENANCE' },
];

// Видът на документа в диалога „добави фактури към документ". Стоковата разписка липсваше, затова
// обект, който нарочно е на разписка (`payment.payment_type = 1`), не можеше да се обедини, без
// типът да бъде пренаписан на фактура - `DocumentService.saveInvoicesToDocument` разпространява
// избраното върху документа И върху всяко от задълженията. Двете стойности отговарят на
// `DocumentType.INVOICE` / `DocumentType.RECEIPT`.
export const invoicePaymentTypes = [
    { name: 'invoice', value: 'INVOICE' },
    { name: 'receipt', value: 'RECEIPT' },
];

export const invoiceStateValue = (name: string | undefined): string => {
    let option = invoiceStateOptions.find((option) => option.name === name);
    return option ? <string>option.value : '';
};

export const invoicePaymentValue = (name: string | undefined): string => {
    let option = invoicePaymentOptions.find((option) => option.name === name);
    return option ? <string>option.value : invoicePaymentOptions[0].value;
};
